(() => {
  // Search and product links work natively; JavaScript only adapts the theme menu.
  if (window.FleecevilleFleeceFinder) {
    window.FleecevilleFleeceFinder.initialize(document);
    return;
  }

  const instances = new Map();

  function initialize(scope) {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-fv-finder]')) roots.push(scope);
    scope.querySelectorAll('[data-fv-finder]').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (instances.has(root)) return;
      const details = root.querySelector('[data-fv-finder-themes]');
      if (!details) return;

      const mobile = window.matchMedia('(max-width: 620px)');
      const updateLayout = () => { details.open = !mobile.matches; };
      updateLayout();
      mobile.addEventListener('change', updateLayout);
      instances.set(root, () => mobile.removeEventListener('change', updateLayout));
    });
  }

  function unload(scope) {
    instances.forEach((cleanup, root) => {
      if (root === scope || scope.contains(root)) {
        cleanup();
        instances.delete(root);
      }
    });
  }

  window.FleecevilleFleeceFinder = { initialize };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
